import { Input } from 'antd'
import { useCallback, useState } from 'react'
import BaseEditingAttributesCell from './BaseEditingAttributesCell'
import BaseEditingCellWithChars from './BaseEditingCellWithChars'


EditingStringCell = ({ defaultValue, r, c }) ->

  [value, setValue] = useState(defaultValue)

  el = useCallback((elem) ->
    elem?.focus()
    window.onkeydown = null
  , [])


  <BaseEditingCellWithChars defaultValue={defaultValue} setValue={setValue}>
    <BaseEditingAttributesCell value={value} initialValue={defaultValue} r={r} c={c}>
      <Input
        className="mousetrap"
        value={value}
        onChange={({ target: { value }}) -> setValue(value)}
        style={{
          background: 'none',
          fontSize: '9pt',
          border: 'none',
          padding: 0,
          boxShadow: 'none',
          zIndex: 5
        }}
        ref={el}
      />
    </BaseEditingAttributesCell>
  </BaseEditingCellWithChars>

export default EditingStringCell